import AdminSchoolClasses from './AdminSchoolClasses';
export default AdminSchoolClasses;
